import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { SelectOption, TemplateSelectComponent } from "../../templates/template-select/template-select.component";

@Component({
  standalone: true,
  selector: "app-prefix-idj",
  imports: [TemplateSelectComponent],
  templateUrl: "./prefix-idj.component.html",
  styleUrl: "./prefix-idj.component.less",
})
export class PrefixIdjComponent extends PrefixComponent<string> {
  @Input()
  public options: SelectOption[];
  public multiple: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.characters = ALLOWED_CHARACTERS["idj"];
  }
}
